// removed by extract-text-webpack-plugin
module.exports = {"card":"NVDrDewAGDDHUspMU-kRj","title":"_2nQfgQDBdcFurWyhaF0de","icon":"_3xmy4gT6eCwT3tRJqxdJW1","description":"_30Cp_BJ4e5-oetAk8a6VdD","active":"_33Jh3GaF-73GOseJtT5vjS","cardWrapper":"_3O-hf9BzkE04KJK_9_gNOT","cardContent":"_12qAKDYPFA184Zm8d-LD1C"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/Atom/Card/style.css
// module id = 363
// module chunks = 39